// src/plugins/branding_plugin.js
import branding_service from '@/services/branding_service';

export default {
  install(app) {
    // Make branding service available globally
    app.config.globalProperties.$branding = branding_service;
    
    // Provide reactive branding data
    app.provide('branding', branding_service);
  }
};